var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"statistical-analysis-skeleton-delays-and-response-times-dossier-bases"},[_c('statistical-analysis-skeleton-dossier-navigation-items'),_c('statistical-analysis-skeleton-table')],1)}
var staticRenderFns = []

export { render, staticRenderFns }